import React, { useState } from "react";
import { FeedItemEvent } from "../../../server/feed/buildfeed";
import { User } from "../models/users";
import { SmallButton } from "../DesignSystem/SmallButton";
import { Countdown } from "../DesignSystem/Countdown";
import { UpcomingCard } from "../DesignSystem/UpcomingCard";
import { EventModal } from "../DesignSystem/EventModal";

export const EventCard = ({
  item,
  user,
}: {
  item: FeedItemEvent;
  user: User | undefined;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <UpcomingCard
        onClick={() => setIsModalOpen(true)}
        image={item.image}
        imageAlt={item.title}
        title={item.title}
        subtitle={
          <>
            <Countdown dark minimal until={new Date(item.start)} /> from now
          </>
        }
        rightContent={
          user?.admin ? (
            <SmallButton to={`/admin/event/${item.id}`}>Edit</SmallButton>
          ) : undefined
        }
      />
      <EventModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={item.title}
        description={item.description}
        url={item.url}
        start={new Date(item.start)}
        image={item.image}
      />
    </>
  );
};
